import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import { IoMdArrowDropdown, IoMdArrowDropright } from 'react-icons/io';

function Links({ routes }) {
    const [isOpen, setIsOpen] = useState({});
    const location = useLocation();

    const activeIcon = useColorModeValue('white', 'black');
    const textColor = useColorModeValue('brand.500', 'white');
    const bgColor = useColorModeValue('#FFC000', 'white');

    // Simulated user data
    const userData = { role: 3 };
    const isMeAdmin = userData.role !== 4;

    const activeRoute = path => location.pathname.includes(path);

    useEffect(() => {
        const newState = {};
        routes.forEach(route => {
            if (route.items) {
                newState[route.name] = route.items.some(child => activeRoute(child.path));
            }
        });
        setIsOpen(newState);
    }, [location.pathname, routes]);

    const createLinks = (routes) =>
        routes
            .filter(route => !route.hideLink)
            .filter(route => (isMeAdmin || route.permission !== 'Admin'))
            .map((route, idx) => {
                const isActive = route.items
                    ? route.items.some(child => activeRoute(child.path))
                    : activeRoute(route.path);

                const menuOpen = isOpen[route.name];

                if (route.items) {
                    return (
                        <Box key={idx} py="5px" bg={menuOpen || isActive ? bgColor : 'transparent'}>
                            <HStack
                                _hover={{ cursor: 'pointer' }}
                                onClick={() =>
                                    setIsOpen(prev => ({
                                        ...prev,
                                        [route.name]: !prev[route.name]
                                    }))
                                }
                                spacing="22px"
                                py="5px"
                                ps="10px"
                            >
                                <Flex w="100%" alignItems="center">
                                    <Box color={isActive ? activeIcon : textColor} me="18px">
                                        {route.icon}
                                    </Box>
                                    <Text
                                        me="auto"
                                        color={isActive ? activeIcon : textColor}
                                        fontWeight={isActive ? 'bold' : 'normal'}
                                    >
                                        {route.name}
                                    </Text>
                                </Flex>
                                <Box>
                                    {menuOpen
                                        ? (
                                            <IoMdArrowDropdown size={30} />
                                        )
                                        : (
                                            <IoMdArrowDropright size={30} />
                                        )}
                                </Box>
                            </HStack>
                            {menuOpen && (
                                <Box ps="30px" py="2px">
                                    {route.items.map((child, childIdx) => (
                                        <NavLink key={childIdx} to={child.layout + child.path}>
                                            <HStack py="5px" ps="10px" spacing="22px">
                                                <Flex alignItems="center">
                                                    <Box
                                                        color={activeRoute(child.path) ? activeIcon : textColor}
                                                        me="18px"
                                                    >
                                                        {child.icon}
                                                    </Box>
                                                    <Text color={activeRoute(child.path) ? activeIcon : textColor}>
                                                        {child.name}
                                                    </Text>
                                                </Flex>
                                            </HStack>
                                        </NavLink>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    );
                }

                return (
                    <Box key={idx} py="5px" bg={isActive ? bgColor : 'transparent'}>
                        <NavLink to={route.layout + route.path}>
                            <HStack spacing="22px" py="5px" ps="10px">
                                <Flex w="100%" alignItems="center">
                                    <Box color={isActive ? activeIcon : textColor} me="18px">
                                        {route.icon}
                                    </Box>
                                    <Text
                                        me="auto"
                                        color={isActive ? activeIcon : textColor}
                                        fontWeight={isActive ? 'bold' : 'normal'}
                                    >
                                        {route.name}
                                    </Text>
                                </Flex>
                            </HStack>
                        </NavLink>
                    </Box>
                );
            });

    return <>{createLinks(routes)}</>;
}

export default Links;
